import { GuidanceRequestTemplateSection } from "@/components/settings/GuidanceRequestTemplateSection";
import { KickoffEmailTemplateSection } from "@/components/settings/KickoffEmailTemplateSection";
import { PageHeader } from "@/components/shared/page-header";

export function SettingsTemplatesPage() {
  return (
    <div className="space-y-10">
      <section className="space-y-4">
        <PageHeader title="Guidance Request Template" />
        <GuidanceRequestTemplateSection />
      </section>
      <section className="space-y-4">
        <PageHeader title="Kickoff Email Template" />
        <KickoffEmailTemplateSection />
      </section>
    </div>
  );
}
